import { IPlaceOrderApi } from '../api/placeOrderApi'
import {
  ApiError,
  autoPlayService,
  ErrorType,
  setErrorPopupData,
  useChipSetStore,
  usePlayerStore,
  useVoucherStore,
} from '@slot-nx/core'
import { useGameStore } from '../../game/store/GameStore'
import { spinService } from '../../game'
import { gameConfig } from '../../../config'
import { Container } from 'pixi.js'
import { sleep } from '../../game/util/gameUtil'
import { useGodziDropStore } from '../../godziDrop/store/godziDropStore'

export class PlaceOrderService {
  private _api: IPlaceOrderApi
  constructor(api: IPlaceOrderApi) {
    this._api = api
  }

  async placeOrder() {
    const chipSetStore = useChipSetStore.getState()
    const isVoucherTime = useGameStore.getState().isVoucherTime
    const { fixedStake, currentVoucherId } = useVoucherStore.getState()
    const stake = isVoucherTime ? fixedStake : chipSetStore.computed.currentStake
    const isExtraBet = useGameStore.getState().isAnteBet
    const currentBalance = usePlayerStore.getState().balance
    const payStake = isExtraBet ? stake * 1.25 : stake

    try {
      if (currentBalance < payStake) {
        throw new ApiError(ErrorType.InsufficientBalance)
      }
      const { balance, mainGame, totalPayout, freeGame, godziDrop, eventInfo, slotVoucherSummary, settledBalance, returnCode } = await this._api.placeOrder({
        stake,
        isExtraBet,
        voucherId: currentVoucherId,
      })

      if (returnCode === 23) {
        throw new ApiError(ErrorType.SessionExpired)
      }

      usePlayerStore.setState({
        balance: balance,
        lastSettledBalance: settledBalance,
      })

      useGameStore.setState({
        gameResult: {
          mainGame,
          totalPayout,
          freeGame,
        },
        freeGameType: mainGame.freeGameType,
        multiplierReelInfo: mainGame.multiplierReel,
      })

      useGodziDropStore.setState({
        godziResult: godziDrop,
        eventInfo,
        godziDropFreeGameType: godziDrop.roundGameResult[0]?.mainGame.freeGameType,
      })

      useVoucherStore.setState(state => ({
        tempSlotVoucher: slotVoucherSummary,
        remainSpin: state.remainSpin - 1,
      }))
    }
    catch (e) {
      autoPlayService.cancel()
      if (e instanceof ApiError && e.type === ErrorType.InsufficientBalance) {
        setErrorPopupData(ErrorType.InsufficientBalance)
      }
      else if (e instanceof ApiError && e.type === ErrorType.SessionExpired) {
        setErrorPopupData(ErrorType.SessionExpired)
      }
      else {
        setErrorPopupData(ErrorType.SystemError)
      }
      throw e
    }
  }

  public async remainTable() {
    await sleep(1000)
    const reels = spinService.reelNodeRef
    reels.children.forEach((reel) => {
      const reelLength = (reel.children as Container[]).length - 1
      reel.children?.forEach((symbol, symbolIndex) => {
        (symbol as Container).y = gameConfig.nodeHeight * (reelLength - symbolIndex)
      })
    })
  }
}
